import { rest } from "msw";
import { mockOutboundProduct, mockOutboundSearchConfirm, } from "./outbound.mocks";
/**
 * @description 출고 현황 관련 핸들러
 */
const outboundConfirmHandlers = [
    // 출고 현황 조회
    rest.get("/outbound-confirm/commercial", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockOutboundSearchConfirm));
    }),
    rest.get("/outbound-confirm/research", (_, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockOutboundSearchConfirm));
    }),
];
/**
 * @description 출고 현황 상세 관련 핸들러
 */
const outboundProductHandlers = [
    // 출고 현황 제품 조회
    rest.get("/outbound-confirm/commercial/:outboundId", (req, res, ctx) => {
        const outboundId = Number(req.params.outboundId);
        if (isNaN(outboundId)) {
            return res(ctx.status(400), ctx.json({ message: "유효하지 않은 ID입니다." }));
        }
        const filteredInboundProduct = mockOutboundProduct.filter((product) => product.id === outboundId);
        if (!filteredInboundProduct) {
            return res(ctx.status(404), ctx.json({ message: "존재하지 않는 출고 제품입니다." }));
        }
        return res(ctx.status(200), ctx.json(filteredInboundProduct));
    }),
    rest.get("/outbound-confirm/research/:outboundId", (req, res, ctx) => {
        const outboundId = Number(req.params.outboundId);
        if (isNaN(outboundId)) {
            return res(ctx.status(400), ctx.json({ message: "유효하지 않은 ID입니다." }));
        }
        const filteredInboundProduct = mockOutboundProduct.filter((product) => product.id === outboundId);
        if (!filteredInboundProduct) {
            return res(ctx.status(404), ctx.json({ message: "존재하지 않는 출고 제품입니다." }));
        }
        return res(ctx.status(200), ctx.json(filteredInboundProduct));
    }),
];
export const outboundHandlers = [
    // ...outboundRequestHandlers,
    ...outboundConfirmHandlers,
    ...outboundProductHandlers,
];
